import { Action } from "redux";

import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";
import { SET_THEME, TOGGLE_THEME } from "./constants";

/**
 * Definice stavu pro téma aplikace.
 * Obsahuje informaci o barevném tématu aplikace.
 */
export type ThemeState = ApplicationTheme;

export interface IToggleThemeAction extends Action<typeof TOGGLE_THEME> {}

export class IToggleThemeAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === TOGGLE_THEME;
    }
}

export interface ISetThemeAction extends Action<typeof SET_THEME> {
    readonly payload: {
        readonly theme: ApplicationTheme;
    };
}

export class ISetThemeAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && instance.type === SET_THEME;
    }
}
